import { Breakpoint } from "apps/website/maps/Breakpoint.map";
import { State } from "apps/website/utils/misc/state";

import { legacySizeCollectionMap } from "../../base/Text/Text.map";
import { IText } from "../../base/Text/Text";

export type AccordionType = "default" | "horizontal-rule" | "full-border" | "footer" | "underline" | "preview";

export type BreakpointState = {
  [key in Breakpoint]?: State
};

export const TEXT_MAP: Record<AccordionType, Omit<IText, "children">> = {
  default: {
    display: "subtitle",
    size: legacySizeCollectionMap.titleSm,
    align: "default",
  },
  "horizontal-rule": {
    display: "subtitle",
    size: legacySizeCollectionMap.titleSm,
    align: "center",
  },
  underline: {
    display: "subtitle",
    size: legacySizeCollectionMap.titleSm,
    align: "center",
  },
  "full-border": {
    display: "subtitle",
    size: legacySizeCollectionMap.titleSm,
    align: "default",
  },
  footer: {
    display: "title",
    size: "default",
    align: "default",
  },
  preview: {
    display: "subtitle",
    size: legacySizeCollectionMap.titleSm,
    align: "default",
  },
};

const ROOT_CLASSES_NOT_DEFAULT = "px-4 mb-2";

export const ROOT_CLASS_MAP: Record<AccordionType, string> = {
  default: "border-b-2 border-solid border-black theme-footer:border-light-grey lg:theme-footer:border-none",
  underline: `${ROOT_CLASSES_NOT_DEFAULT} flex flex-col`,
  "full-border": `${ROOT_CLASSES_NOT_DEFAULT} border-2 border-solid`,
  preview: `${ROOT_CLASSES_NOT_DEFAULT}`,
  "horizontal-rule": `${ROOT_CLASSES_NOT_DEFAULT}`,
  footer: `${ROOT_CLASSES_NOT_DEFAULT}`,
};
